import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { format, parse } from 'date-fns'
import { IMotivosRevision } from '../../types/producto'
import ResultadosDeteccionCards from './CardsDetalle'

interface Props {
  open: boolean
  setOpen: (op: boolean) => void
  motivos: IMotivosRevision[]
}
/* eslint-disable react/prop-types */
const MotivosRevision: React.FC<Props> = ({ open, setOpen, motivos }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth={isMobile ? 'lg' : false}
      fullWidth={isMobile}
      PaperProps={{
        sx: { overflowX: 'hidden' }
      }}
    >
      <DialogTitle>Motivos de Revisión</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {motivos.map((m: IMotivosRevision) => (
          <Box key={m.fechaDeteccion + m.motivo} sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <Typography variant="subtitle1" fontWeight={'bold'}>
              {m.motivo}
            </Typography>
            <ResultadosDeteccionCards detalle={m.detalle} />
            <Typography variant="body2">
              {`Se detectó el: ${format(parse(m.fechaDeteccion, 'yyyy-MM-dd HH:mm:ss', new Date()), 'dd/MM/yyyy, HH:mm:ss')}`}
            </Typography>
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <IconButton
          edge="end"
          onClick={() => setOpen(false)}
          style={{
            position: 'absolute',
            top: '0',
            right: '0',
            paddingRight: '18px'
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogActions>
    </Dialog>
  )
}

export default MotivosRevision
